import {createApp} from 'vue'
import Store from 'store'
import options from './ImageSpotFiftyFifty.options'

const component = createApp(options).use(Store)

const el = '.nlx-component--image-spot-fifty-fifty'
const DOM = document.querySelector(el)

if(DOM){
    component.mount(el)
}

